module.exports = __webpack_public_path__ + "static/media/wizualizacja-76.3cf6966c.png";